import AppForm from '../app-components/Form/AppForm';

Vue.component('app-factory-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                parent_id:  '' ,
                name:  '' ,
                code:  '' ,
                enabled:  false ,
                print_orientation:  0 ,
                
            },
            parent_selected:  '' ,
        }
    },
    methods:{
        updateApprovers(appFactory) {
            if (appFactory !== null) {
                this.form.parent_id = appFactory.id;
            }else{
                this.form.parent_id = null;
            }
        },
        onRemove(appFactory) {
            this.form.parent_id = null;
        },
    },
    props: {
        parentFactory: {
            type: Object,
            default: {}
        }
    },
    mounted: function () {  
        this.parent_selected = this.parentFactory
    }

});